import React, { useState, useEffect } from 'react'
import {
  Col,
  Panel,
  Row,
  Modal,
  Button,
  Icon,
  Message,
  Table,
  ControlLabel,
  Input,
  ButtonToolbar,
  Uploader,
  ButtonGroup,
  IconButton,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import {
  isImageOrPdf,
  isImageOrPdfOrMsFile,
  isValidators,
  requiredFiled,
} from '../../../utils/ValidatorUtils'
import notification from '../../../utils/notification'
import { isEmpty } from 'lodash-es'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import {
  deleteDocumentManageIaFile,
  downloadDocumentManageIaFile,
  getEmailAttchMange,
  saveDocumentManageIa,
  saveEmailAttchMange,
  searchDocumentManageIa,
} from '../../../redux/actions/IaDucumentManagement'
import {
  DEFAULT_ERR_MSG,
  DELETE_FILE_FAILED_MSG,
  DELETE_FILE_SUCCESS_MSG,
  SAVE_SUCCESS_MSG,
} from '../../../constants/msgText'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import TooltipButton from '../../../components/buttons/TooltipButton'
import InputForm from '../../../components/forms/input/InputForm'

export default function EmailAttManagementWidget({ schema, ...props }) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(25)
  const [page, setPage] = useState(1)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [dataTable, setDataTable] = useState()
  // const [dataTableLinked, setDataTableLined] = useState()
  const [isAddData, setIsAddData] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [rowId, setRowId] = useState()
  const [requestBody, setRequestBody] = useState()

  const twoCol = {
    first: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
    second: {
      _lg: 12,
      _md: 12,
      _sm: 24,
      _xs: 24,
    },
    full: {
      _lg: 24,
      _md: 24,
      _sm: 24,
      _xs: 24,
    },
  }

  useEffect(() => {
    console.log('scheeeee => ', schema)
    setDataTable(schema?.values || [])
    // setFormSchemaLinked(schemaLinked)
    // onClearSearchFiles()
    // callApiSearchFiles({ filesName: '' })
  }, [])

  const onSubmitSearchFiles = async (data) => {
    console.log('onSubmitSearchFiles => ', data)
    const request = {
      filesName: data?.documentName || '',
    }

    await callApiSearchFiles(request)
  }

  const onClearSearchFiles = async () => {
    // onClearSearch()
    await callApiSearchFiles()
  }

  // const onClearSearch = () => {
  //   setValue(schema?.searchForm?.documentName?.name, '')
  //   setValue(schema?.addForm?.documentName?.name, '')
  //   setValue(schema?.addForm?.attachFiles?.name, '')
  //   setValue(schema?.addForm?.note?.name, '')
  // }

  const callApiSearchFiles = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getEmailAttchMange()
      console.log('ressss ooo => ', response)
      if (response) {
        setDataTable(response?.emailAttachedForm?.values || [])
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleAddForm = () => {
    setIsAddData(true)
    onClearSearchFiles()
  }

  const onSubmit = async (data) => {
    console.log('onSubmit => ', data)
    console.log('requestttt => ', requestBody)

    console.log('schema => ', schema.values)

    setIsLoading(true)
    startLoading()
    try {
      let oldFile = schema?.values?.find((e) => e?.id == requestBody?.id)?.filePath || ''
      const formData = new FormData()
      formData.append('Id', requestBody?.id || '')
      formData.append('FileName', requestBody?.fileName || '')
      // formData.append('Note', data?.note || '')
      formData.append('FilePathStr', oldFile || '')
      formData.append('FileTypeId', requestBody?.fileTypeId || 0)

      data.attachFiles &&
        data.attachFiles?.forEach((element) => {
          formData.append('FilePath', element.blobFile)
        })

      const response = await saveEmailAttchMange(formData)
      console.log('ressss ooo => ', response)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        setDataTable(response?.emailAttachedForm?.values || [])
        // onClearSearch()
        setIsAddData(false)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onFileHandle = async (rowData, type) => {
    console.log('rowdtat => ', type)

    // return false

    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadDocumentManageIaFile(rowData.filePath)

      if (type == 'download') {
        downloadFile(file, rowData?.fileName || rowData?.id)
      } else {
        previewFile(file, rowData?.fileName)
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const delFiles = async () => {
    // console.log('idddd => ', id)
    // return false
    setIsLoading(true)
    startLoading()
    try {
      // { id: rowId }
      const response = await deleteDocumentManageIaFile({ id: rowId })
      // console.log('ressss ooo => ', response)
      if (response.success) {
        notification.open('success', {
          title: DELETE_FILE_SUCCESS_MSG,
          duration: 5000,
        })
        // setDataTable(response?.values || [])
        onClearSearchFiles()
        setIsShowConfirmDelete(false)
      } else {
        notification.open('error', {
          title: DELETE_FILE_FAILED_MSG,
          duration: 5000,
        })
        setIsShowConfirmDelete(false)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log('error', e)
        if (e?.response?.data) {
          notification.open('error', {
            title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
            duration: 5000,
          })
        } else {
          setError({})
        }
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onUpload = (rowData) => {
    console.log('onUpload ', rowData)
    setIsAddData(true)
    setRequestBody(rowData)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={schema?.header || ''} bordered>
        <Table wordWrap height={400} loading={isLoading} data={dataTable}>
          <Column align="center" width={100} fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1 + (page * displayLength - displayLength)
              }}
            </Cell>
          </Column>

          <Column flexGrow={1}>
            <HeaderCell>ชื่อ</HeaderCell>
            <Cell dataKey="fileName" />
          </Column>

          <Column width={220} align="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData) => {
                // console.log('rowdata => ', rowData)
                return (
                  <>
                    <ButtonGroup>
                      <TooltipButton
                        isStart={true}
                        icon="eye"
                        tooltip={`แสดง`}
                        disabled={!rowData.filePath}
                        onClick={(e) => onFileHandle(rowData, 'preview')}
                      />
                      <TooltipButton
                        isStart={false}
                        icon="download2"
                        tooltip={`ดาวน์โหลด`}
                        disabled={!rowData.filePath}
                        onClick={(e) => onFileHandle(rowData, 'download')}
                      />
                      <TooltipButton
                        isStart={false}
                        icon="upload2"
                        tooltip={`อัพโหลด`}
                        iconStyle={{
                          backgroundColor: '#0d6efdad',
                          borderRadius: '0px 0px 0px 0px',
                        }}
                        // disabled={isLoading}
                        onClick={(e) => onUpload(rowData)}
                      />
                      <TooltipButton
                        isStart={false}
                        icon="trash-o"
                        tooltip={`ลบ`}
                        disabled={!rowData.filePath}
                        iconStyle={{
                          backgroundColor: '#fb8a81',
                          borderRadius: '0px 4px 4px 0px',
                          borderColor: 'fb8a81',
                        }}
                        onClick={() => {
                          // delFiles(rowData.id)
                          setRowId(rowData.id)
                          setIsShowConfirmDelete(true)
                        }}
                      />
                    </ButtonGroup>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>

      <Modal
        backdrop
        show={isAddData}
        size="md"
        onHide={() => {
          setIsAddData(false)
        }}
        // style={{backgroundColor: '', color: '', borderRadius: '', borderColor}}
      >
        <Modal.Header>
          <Modal.Title>
            <div style={{ padding: 5 }}>{`${schema?.addForm?.title}  ${
              requestBody?.fileName || ''
            }`}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginBottom: 10 }}>
            <Row>
              <Col
                lg={twoCol.full._lg}
                md={twoCol.full._md}
                sm={twoCol.full._sm}
                xs={twoCol.full._xs}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                }}
              >
                <ErrorMessage
                  error={errors[schema?.addForm?.attachFiles?.name]}
                  style={{ marginBottom: 10 }}
                />

                <ControlLabel>
                  {requiredFiled(
                    schema.addForm.attachFiles.validators,
                    schema.addForm.attachFiles.header
                  )}
                </ControlLabel>

                {schema?.addForm?.attachFiles?.fileType && (
                  <Message
                    style={{ marginTop: 10, marginBottom: 10 }}
                    showIcon
                    type="info"
                    description={`ชนิดที่รองรับ ${
                      schema?.addForm?.attachFiles?.fileType || '.docx, .xlsx, .pdf'
                    } และขนาดไฟล์ไม่เกิน ${schema?.addForm?.attachFiles?.fileSize || 50} MB`}
                  />
                )}

                <Controller
                  name={schema?.addForm?.attachFiles?.name}
                  control={control}
                  defaultValue={undefined}
                  rules={isValidators(schema?.addForm?.attachFiles?.validators)}
                  render={(props) => {
                    return (
                      <Uploader
                        accept={schema?.addForm?.attachFiles?.fileType || '.docx, .xlsx, .pdf'}
                        draggable
                        autoUpload={false}
                        multiple={false}
                        fileList={props.value || []}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            let file = fileList[fileList.length - 1]

                            if (
                              file.blobFile.size >
                              (schema.addForm?.attachFiles?.fileSize || defaultMaxFileSize) *
                                1024 *
                                1024
                            ) {
                              notification.open('error', {
                                title: `ขนาดไฟล์เกิน ${
                                  schema.addForm.attachFiles.fileSize || defaultMaxFileSize
                                } MB`,
                                duration: 5000,
                              })
                              return
                            }

                            if (isImageOrPdfOrMsFile(file.blobFile.type)) {
                              let files = []
                              files.push(fileList[fileList.length - 1])
                              props.onChange(files)

                              // props.onChange(fileList)
                              //setFileTypeError(false)
                            } else {
                              //setFileTypeError(true)
                              notification.open('error', {
                                title:
                                  'ชนิดที่รองรับ ' + schema.addForm.attachFiles.fileType ||
                                  '.docx, .xlsx, .pdf',
                                duration: 5000,
                              })
                            }
                          }
                        }}
                      >
                        <div style={{ lineHeight: '100px' }}>
                          <Icon size="4x" icon="upload2" />
                          <small
                            style={{
                              marginTop: '-70px',
                              display: 'block',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                          </small>
                        </div>
                      </Uploader>
                    )
                  }}
                />
              </Col>
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar>
            <SaveButton
              style={{ minWidth: 120 }}
              onClick={handleSubmit(onSubmit)}
              disabled={isLoading}
            >
              {schema.addForm.button.save}
            </SaveButton>
            <CancelButton
              style={{ minWidth: 120 }}
              disabled={isLoading}
              onClick={() => {
                setIsAddData(false)
                setRequestBody()
              }}
            >
              {schema.addForm.button.cancel}
            </CancelButton>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>

      <ConfirmWidget
        title={'ยืนยันลบเอกสาร'}
        show={isShowConfirmDelete}
        //detail={'ยืนยันลบเอกสาร'}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={delFiles}
      />
    </>
  )
}
